module.exports = __webpack_public_path__ + "assets/notifications.b1420a67.svg";